// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { useState } from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import EventTemplatesWrapper from './EventTemplatesListWrapper';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { mapFromIdeaToTemplate } from '../../../../infrastructure/utils/events';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const EventIdeas = ({ ideas, children }) => {
  const [childrenWithProps, setChildrenWithProps] = useState(null);

  const onIdeaClick = idea => {
    const eventTemplate = {
      eventType: idea.type,
      eventCategory: idea.category,
      eventTitle: idea.title,
      eventLocation: idea.location,
      defaultImageId: undefined,
      assetImage: idea.customImage,
    };
    const childs = React.Children.map(children, child => {
      if (React.isValidElement(child)) {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        return React.cloneElement(child, { eventTemplate });
      }
      return child;
    })[0];
    setChildrenWithProps(childs);
  };
  return (
    <>
      {childrenWithProps || (
        <EventTemplatesWrapper
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/prop-types
          templates={ideas.map(mapFromIdeaToTemplate)}
          onTemplateClick={onIdeaClick}
          originalData={ideas}
        />
      )}
    </>
  );
};

export default React.memo(EventIdeas);
